/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldAngle } from '@blockly/field-angle';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.ARDUINOUNO_ENTRADAS_button_TREN = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Boton.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField('Sensor de paso de')
      .appendField(new Blockly.FieldDropdown([
        ['Retiro', '4'], ['Austria Sur', '6'], ['Austria Norte', '7'],
      ]), 'NPIN');
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_BUTTON_TOOLTIP);
  },
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_motor_tren_avanzar = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/MotorDC.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField('Comenzar el recorrido del tren hacia');
    this.appendDummyInput()
      .appendField('la luz')
      .appendField(new Blockly.FieldDropdown([['Retiro', '0'], ['Pilar', '1']]), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
};

Blockly.Blocks.ARDUINOUNO_SALIDAS_motor_tren_frenar = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/MotorDC.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField('Frenar el recorrido del tren');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
};

// Pin fijo (12), sin dropdown, a diferencia del ARDUINOUNO_SALIDAS_read_dht11 genérico.
Blockly.Blocks.ARDUINOUNO_SALIDAS_read_dht11_tren = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Dht11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ENTRADAS_HUMEDAD, 'H'],
        [Blockly.Msg.LANG_ENTRADAS_TEMPERATURA, 'T'],
      ]), 'TYPE');
    this.appendDummyInput('').appendField('ambiente');
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_READ_DHT11_TOOLTIP);
  },
};

// Sin LCD_DIRECCION: dirección I2C fija (0x27), a diferencia del ARDUINOUNO_lcd_educabot genérico.
Blockly.Blocks.ARDUINOUNO_lcd_educabot_tren = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/LCD.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('NAME').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_LCD_ADVANCED_ROWS)
      .appendField(new Blockly.FieldDropdown([['0', '0'], ['1', '1']]), 'CURSOR_ROW')
      .appendField(Blockly.Msg.LANG_LCD_ADVANCED_COLUMNS_I2C)
      .appendField(new Blockly.FieldDropdown([
        ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'],
        ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'],
        ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'],
      ]), 'CURSOR_COLUMN');
    this.appendDummyInput().appendField('de la cartelera');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_DEF_TOOLTIP);
  },
};

Blockly.Blocks.ARDUINOUNO_salidas_led_tren = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField('la luz')
      .appendField(new Blockly.FieldDropdown([['Derecha', '11'], ['Izquierda', '10']]), 'NPIN')
      .appendField('del semaforo del tren');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
};

// Sin NPIN: mueve dos servos fijos (barrera de paso) en lockstep con el mismo ángulo.
Blockly.Blocks.ARDUINOUNO_servo_move_tren = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Servo.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN').appendField('la barrera de paso');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
};

// Validador propio, no el de slider_angle de mathBlocks.js: pliega módulo 360 y, si supera 120,
// resta 120 (un wrap discontinuo, no un clamp).
const angleTrenValidator = function (text) {
  if (text === null) return null;
  let n = parseFloat(text || 0);
  if (Number.isNaN(n)) return null;
  n %= 360;
  if (n < 0) n += 360;
  if (n > 120) n -= 120;
  return String(n);
};

Blockly.Blocks.slider_angle_tren = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldAngle(90, angleTrenValidator, { symbol: '' }), 'angulo');
  },
};
